import { DEV_BASE_URL, BASE_URL } from "../lib/constants";
export const API_URL = process.env.NODE_ENV === "development" ? DEV_BASE_URL : BASE_URL



export const StoreUserAuthToken = (token) => {
  if (token) {
    return localStorage.setItem("user_token", token);
  }
};


export const StoreUserDetails = (details) => {
  details = JSON.stringify(details);
  return localStorage.setItem("user", details);
};

export const GetUserDetails = () => {
  const details = localStorage.getItem("user_details");
  return details ? JSON.parse(details) : undefined;
};

export const GetUserAuthToken = () => {
  // useful when school is loaded as an iframe from pledre account dashboard
  // and the localstorage data is to be overwritten by a url token
  // use the default user_token only if no user_token in url
  return  localStorage.getItem("user_token")
  
};


